import { navigate } from 'gatsby'
import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { getPostSubCategories } from '@/helpers/get-subcategory'
import {
  getEventsByRelatedCat,
  getEventsByRelatedTag,
  getEventsByTime,
} from '@/utils/compareEventsFunc'

import { useCategories } from '../../hooks/useCategories'
import { usePosts } from '../../hooks/usePosts'
import { withTrans } from '../../i18n/withTrans'
import { GET_QUERY } from '../../redux/actions/types'
import ArticleView from './article-view'

const mainCategories = {
  university: {
    description: 'university',
    name: 'University',
  },
  'product-news': {
    name: 'Product',
    description: 'product-news',
  },
  'market-updates': {
    name: 'Market Updates',
    description: 'market-updates',
  },
  research: {
    name: 'Research',
    description: 'research',
  },
  'nft-stories': {
    name: 'NFT Stories',
    description: 'nft-stories',
  },
  'company-news': {
    name: 'Company News',
    description: 'company-news',
  },
  events: {
    name: 'Event',
    description: 'events',
  },
}

const ArticleController = ({ article, location, category, t, i18n }) => {
  // hooks
  const {
    all: posts,
    events,
    university,
    productNews,
    marketUpdates,
    research,
    nftStories,
  } = usePosts()
  const { withSubCategories } = useCategories()
  const dispatch = useDispatch()
  // state
  const [relatedPosts, setRelatedPosts] = useState([])
  const [universityLevel, setUniversityLevel] = useState([])
  const mainCategory = mainCategories[category]
  // local var
  const { href } = location
  const tags = _.get(article, 'tags.nodes')
  const categoriesInObj = _.get(article, 'categories.nodes')
  const subcategory = getPostSubCategories(article)

  const searchTag = (tag) => {
    dispatch({ type: GET_QUERY, payload: tag })
    const url =
      i18n.language === 'en'
        ? `/search?keyword=${tag}`
        : `/${i18n.language}/search?keyword=${tag}`
    navigate(url, { replace: false })
  }
  useEffect(() => {
    const subcategoryUniversity = _.filter(
      categoriesInObj,
      (c) =>
        c.slug.startsWith('advanced') ||
        c.slug.startsWith('beginner') ||
        c.slug.startsWith('intermediate')
    )
    setUniversityLevel(_.head(subcategoryUniversity))
  }, [categoriesInObj])

  useEffect(() => {
    let res = []
    if (mainCategory?.description === 'events' && events) {
      const sortEvents = _.sortBy(
        events.filter((e) => e.node.id !== article.id),
        (a) => {
          const astart = moment(
            `${_.get(a, 'node.acf.eventDatetime.startDate') ?? '01/01/1971'} ${
              _.get(a, 'node.acf.eventDatetime.startTime') ?? '00:00'
            } GMT`,
            'DD/MM/YYYY HH:mm'
          )

          return astart.unix()
        }
      )

      const upcomingEvents = getEventsByTime(sortEvents, false).slice(0, 3)
      const sortedTrending = posts
        .filter((p) => p.node.id !== article.id)
        .sort((a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt))

      while (upcomingEvents.length < 3) {
        upcomingEvents.push(sortedTrending.pop())
      }
      setRelatedPosts(upcomingEvents)
    } else if (mainCategory?.description === 'university' && university) {
      const BeginnerPostSameTopic = []
      const InterPostSameTopic = []
      const AdvancedPostSameTopic = []
      const postWithSameLevelDifTopic = []
      if (!universityLevel) {
        return
      }

      university.forEach((post) => {
        if (post.node.id === article.id) return
        const catArray = _.map(
          _.get(post, 'node.categories.nodes'),
          (x) => x.name
        )
        if (
          subcategory.name &&
          catArray.includes(subcategory.name) &&
          catArray.includes('Beginner')
        ) {
          BeginnerPostSameTopic.push(post)
        }
        if (
          subcategory.name &&
          catArray.includes(subcategory.name) &&
          catArray.includes('Intermediate')
        ) {
          InterPostSameTopic.push(post)
        }
        if (
          subcategory.name &&
          catArray.includes(subcategory.name) &&
          catArray.includes('Advanced')
        ) {
          AdvancedPostSameTopic.push(post)
        }
        if (
          subcategory.name &&
          !catArray.includes(subcategory.name) &&
          catArray.includes(universityLevel.name)
        ) {
          postWithSameLevelDifTopic.push(post)
        }
      })
      BeginnerPostSameTopic.sort(
        (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
      )
      InterPostSameTopic.sort(
        (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
      )
      AdvancedPostSameTopic.sort(
        (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
      )
      postWithSameLevelDifTopic.sort(
        (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
      )

      if (universityLevel.name === 'Beginner') {
        if (
          BeginnerPostSameTopic.length >= 2 &&
          (InterPostSameTopic.length || AdvancedPostSameTopic.length)
        ) {
          res = res.concat(BeginnerPostSameTopic.slice(-2))
          res.push(
            InterPostSameTopic.length
              ? InterPostSameTopic.pop()
              : AdvancedPostSameTopic.pop()
          )
        } else if (
          BeginnerPostSameTopic.length &&
          InterPostSameTopic.length &&
          AdvancedPostSameTopic.length
        ) {
          res = res.concat([
            BeginnerPostSameTopic.pop(),
            InterPostSameTopic.pop(),
            AdvancedPostSameTopic.pop(),
          ])
        } else {
          res = res.concat(postWithSameLevelDifTopic.slice(-3))
        }
      } else if (universityLevel.name === 'Intermediate') {
        if (
          InterPostSameTopic.length >= 2 &&
          (BeginnerPostSameTopic.length || AdvancedPostSameTopic.length)
        ) {
          res = res.concat(InterPostSameTopic.slice(-2))
          res.push(
            BeginnerPostSameTopic.length
              ? BeginnerPostSameTopic.pop()
              : AdvancedPostSameTopic.pop()
          )
        } else if (
          BeginnerPostSameTopic.length &&
          InterPostSameTopic.length &&
          AdvancedPostSameTopic.length
        ) {
          res = res.concat([
            BeginnerPostSameTopic.pop(),
            InterPostSameTopic.pop(),
            AdvancedPostSameTopic.pop(),
          ])
        } else {
          res = res.concat(postWithSameLevelDifTopic.slice(-3))
        }
      } else {
        if (
          AdvancedPostSameTopic.length >= 2 &&
          (BeginnerPostSameTopic.length || InterPostSameTopic.length)
        ) {
          res = res.concat(AdvancedPostSameTopic.slice(-2))
          res.push(
            BeginnerPostSameTopic.length
              ? BeginnerPostSameTopic.pop()
              : InterPostSameTopic.pop()
          )
        } else if (
          BeginnerPostSameTopic.length &&
          InterPostSameTopic.length &&
          AdvancedPostSameTopic.length
        ) {
          res = res.concat([
            BeginnerPostSameTopic.pop(),
            InterPostSameTopic.pop(),
            AdvancedPostSameTopic.pop(),
          ])
        } else {
          res = res.concat(postWithSameLevelDifTopic.slice(-3))
        }
      }
      setRelatedPosts(res)
    } else if (mainCategory?.description === 'product-news' && productNews) {
      const sortedNews = productNews
        .filter((p) => p.node.id !== article.id)
        .sort((a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt))
      res = res.concat(sortedNews.slice(-2))
      let validUniversityTags = categoriesInObj
        .filter(
          (t) =>
            t.slug === 'defi-wallet-product-news' ||
            t.slug === 'nft-product-news'
        )
        .map((x) => {
          if (x.slug === 'defi-wallet-product-news') {
            return 'defi-university'
          } else {
            return 'nft-university'
          }
        })
      if (validUniversityTags.length) {
        for (let i = 0; i < university.length; i++) {
          let post = university[i]
          if (
            post.node.categories &&
            post.node.categories.nodes.filter((t) =>
              validUniversityTags.some((t2) => t2 === t.slug)
            ).length
          ) {
            res.push(post)
            break
          }
        }
      }
      if (res.length < 3) {
        const sortedUniversity = university.sort(
          (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
        )
        res.push(sortedUniversity.pop())
      }

      setRelatedPosts(res)
    } else if (
      mainCategory?.description === 'market-updates' &&
      marketUpdates
    ) {
      const sortedMarketUpdates = marketUpdates
        .filter((p) => p.node.id !== article.id)
        .sort((a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt))
      const sortedProductNews = productNews.sort(
        (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
      )
      const sortedUpcomingEvents = getEventsByTime(events, false).sort(
        (a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt)
      )
      if (
        sortedMarketUpdates.length &&
        sortedProductNews.length &&
        sortedUpcomingEvents.length
      ) {
        res = res.concat(
          sortedMarketUpdates.slice(-1),
          sortedProductNews.slice(-1),
          sortedUpcomingEvents.slice(-1)
        )
      }
      setRelatedPosts(res)
    } else if (mainCategory?.description === 'research' && research) {
      const sortedResearch = research
        .filter((p) => p.node.id !== article.id)
        .sort((a, b) => new Date(a.node.dateGmt) - new Date(b.node.dateGmt))
      res = res.concat(sortedResearch.slice(-3))
      setRelatedPosts(res)
    } else if (mainCategory?.description === 'nft-stories' && nftStories) {
      const sortedNftDesc = nftStories
        .filter((p) => p.node.id !== article.id)
        .sort((a, b) => new Date(b.node.dateGmt) - new Date(a.node.dateGmt))
      let ExistedCat = []
      for (let i = 0; i < sortedNftDesc.length; i++) {
        if (res.length === 3) break
        const catArray = _.map(
          _.get(sortedNftDesc[i], 'node.categories.nodes'),
          (x) => x.name
        )
        if (
          catArray.includes('Celebrities') &&
          !ExistedCat.includes('Celebrities')
        ) {
          ExistedCat.push('Celebrities')
          res.push(sortedNftDesc[i])
        }
        if (catArray.includes('Artists') && !ExistedCat.includes('Artists')) {
          ExistedCat.push('Artists')
          res.push(sortedNftDesc[i])
        }
        if (catArray.includes('Drops') && !ExistedCat.includes('Drops')) {
          ExistedCat.push('Drops')
          res.push(sortedNftDesc[i])
        }
      }

      setRelatedPosts(res)
    } else {
      const tagRelate = getEventsByRelatedTag(
        article,
        posts,
        tags,
        categoriesInObj
      )
      const catRelate = getEventsByRelatedCat(article, posts, categoriesInObj)
      setRelatedPosts(catRelate.concat(tagRelate).slice(0, 3))
    }
  }, [
    posts,
    categoriesInObj,
    tags,
    article,
    mainCategory,
    events,
    universityLevel,
    university,
    subcategory,
    productNews,
    marketUpdates,
    research,
    nftStories,
  ])

  const viewProps = {
    article,
    relatedPosts,
    href,
    category: mainCategory,
    subcategory,
    universityLevel,
    t,
    i18n,
    searchTag,
  }
  return <ArticleView {...viewProps} />
}

export default withTrans(ArticleController)
